import apiClient from './apiClient';
import type { DirectShearData, DirectShearGeneral, DirectShearStage } from '../types/directShear';

export const getDirectShearData = async (
  workOrderDetailKey: string,
): Promise<DirectShearData> => {
  const response = await apiClient.get<DirectShearData>(
    `/workorderdetails/${workOrderDetailKey}/directshear`,
  );
  return response.data;
};

export const saveDirectShearData = async (
  workOrderDetailKey: string,
  general: DirectShearGeneral,
  stages: DirectShearStage[],
  confirmReset = false,
): Promise<{ resetPerformed?: boolean }> => {
  const response = await apiClient.put(`/workorderdetails/${workOrderDetailKey}/directshear`, {
    general,
    stages,
    confirmReset,
  });
  return response.data;
};

// Leeb Hardness Joint Surface 12-reading endpoints
export interface LeebReadingsResponse {
  top: { readingNumber: number; value: number | null }[];
  bottom: { readingNumber: number; value: number | null }[];
  calculatedMean: { top: number | null; bottom: number | null };
}

export const getLeebReadings = async (generalKey: string): Promise<LeebReadingsResponse> => {
  const response = await apiClient.get<LeebReadingsResponse>(`/workorderdetails/leeb/${generalKey}`);
  return response.data;
};

export const saveLeebReadings = async (
  generalKey: string,
  position: 'Top' | 'Bottom',
  readings: (number | null)[],
): Promise<{ mean: number | null }> => {
  const response = await apiClient.put(`/workorderdetails/leeb/${generalKey}`, { position, readings });
  return response.data;
};
